import { MentionModel } from './mention.model';

/**
 * The api definition for creating a new custom mention.
 * Keep the property list below in sync since we can't use this to iterate over the properties nicely.
 */
export type CreateMentionApiModel = Pick<
MentionModel,
'agilityContactId'
| 'agilityOutletId'
| 'attachmentMediaIds'
| 'audienceReach'
| 'adValueUsd'
| 'body'
| 'cityId'
| 'contactId'
| 'contactName'
| 'continentId'
| 'countryId'
| 'countyId'
| 'folderIds'
| 'tagIds'
| 'language'
| 'mediaType'
| 'note'
| 'outletId'
| 'outletName'
| 'provinceId'
| 'publishedDate'
| 'sentiment'
| 'summary'
| 'title'
| 'url'
| 'wordCount'
| 'clipDuration'
| 'images'
>;

/**
 * List of properties included in the create api model so we can easily iterate over them.
 * Keep this in sync with the list above.
 */
export const createMentionApiProperties: string[] = [
    'agilityContactId',
    'agilityOutletId',
    'attachmentMediaIds',
    'audienceReach',
    'adValueUsd',
    'body',
    'cityId',
    'contactId',
    'contactName',
    'continentId',
    'countryId',
    'countyId',
    'folderIds',
    'tagIds',
    'language',
    'mediaType',
    'note',
    'outletId',
    'outletName',
    'provinceId',
    'publishedDate',
    'sentiment',
    'summary',
    'title',
    'url',
    'wordCount',
    'clipDuration',
    'socialData',
    'images'
];
